var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('Spin',{attrs:{"size":"large"}})],1):_c('div',[_c('RoomHeader',{attrs:{"roomId":_vm.roomInfos.id,"roomName":_vm.roomInfos.displayName}}),_c('ActionBody')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }